<template>
  <v-dialog v-model="isOpen" max-width="790" width="530" :persistent="true">
    <v-card class="dialog-box">
      <v-card-title class="headline">
        {{ $t("Delete") + " " + $tc("Cable", 2) }}
      </v-card-title>

      <v-card-text style="padding-bottom: 10px; white-space: normal">
        <div style="padding-bottom: 10px">
          {{ $t("ClusterContainsCablesCreatedManuallyProceed") }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          @click="executeAction('cancel')"
          :ripple="false"
          class="secondary-button"
          style="width: max-content !important;"
          text
        >
          {{ $t("Cancel") }}
        </v-btn>

        <v-flex
          id="overflow-confirm"
          :style="{ width: widthOverflow }"
          style="flex: unset"
        >
          <v-overflow-btn
            :items="confirmOptions"
            v-model="selected"
            segmented
            :loading="loading"
            background-color="accent"
            class="ma-0"
          />
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogDeleteCableWhenDeleteCluster",

  props: {
    /**
     * Defines if the dialog box is open or not.
     */
    open: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      /**
       * Defines if the dialog box is open or not.
       */
      isOpen: false,

      /**
       * Determines the value of the selected option
       */
      selected: null,
    };
  },

  computed: {
    /**
     * Options available to confirm the process
     * @returns {[{callback: (function(): default.computed), text: VueI18n.TranslateResult}, {callback: (function(): default.computed), text: VueI18n.TranslateResult}]}
     */
    confirmOptions() {
      return [
        {
          text: this.$i18n.t("DeleteAll"),
          callback: () => this.$emit("delete-all-cables")
        },
        {
          text: this.$i18n.t("DeleteCablesCreatedAutomatically"),
          callback: () => this.$emit("delete-cables-created-automatically")
        }
      ];
    },

    /**
     * Determines the overflow width
     * @returns {string}
     */
    widthOverflow() {
      return this.selected === "Delete All" ? "120px" : "260px";
    }
  },

  watch: {
    open(newValue) {
      this.isOpen = newValue;
    }
  },

  mounted() {
    this.selected = this.confirmOptions[0].text;
  },

  methods: {
    /**
     * Send an event to the parent to execute the action.
     */
    executeAction(action) {
      this.$emit(action);
    }
  }
};
</script>

<style>
#overflow-confirm .v-input {
  width: 100%;
  box-shadow: 0 3px 1px -4px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.08),
    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}

#overflow-confirm .v-input__slot {
  margin-bottom: 0 !important;
}

#overflow-confirm .v-select__slot,
#overflow-confirm .v-input__append-inner {
  height: 32px !important;
}

#overflow-confirm .v-text-field__details {
  min-height: unset !important;
}

#overflow-confirm .v-btn__content {
  font-size: 12px;
  color: white !important;
  text-transform: capitalize;
}

#overflow-confirm .v-btn:before {
  background-color: unset;
}

#overflow-confirm .v-icon.v-icon {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Dialog/DialogDeleteCableWhenDeleteCluster.vue